import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { isRouteOrDistanceCacheMetricKey, TMetrics } from "@ryde/shared";

interface IProductionLogsStatsTabsMetricsMap {
  metrics?: Partial<TMetrics>;
}

export const ProductionLogsStatsTabsMetricsMap: FC<
  IProductionLogsStatsTabsMetricsMap
> = ({ metrics }) => {
  const { t } = useTranslation();

  if (!metrics || Object.keys(metrics).length === 0) {
    return null;
  }

  return (
    <div className="log__metrics-section">
      <div className="log__metrics-section-title">
        {t("mapCacheStat.metrics.mapMetricsTitle")}
      </div>
      <div className="log__metrics-map-stats">
        {Object.entries(metrics).map(([key, value]) => {
          const typedKey = key as keyof TMetrics;

          if (typedKey === "startedAtTimestamp") {
            return null;
          }

          const isCached = isRouteOrDistanceCacheMetricKey(typedKey);

          return (
            <div key={typedKey} className="log__metrics-map-item">
              <span
                className={clsx("log__metrics-map-label", {
                  [`${"log__metrics-map-label-optimized"}`]: isCached,
                })}
              >
                {t(`mapCacheStat.metrics.${typedKey}`)}:
              </span>
              <span
                className={clsx("log__metrics-map-value", {
                  [`${"log__metrics-map-value-optimized"}`]: isCached,
                })}
              >
                {value}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
